import {Store} from 'vuex'
import axios from 'axios'
import VueI18n from 'vue-i18n'
import Vue from 'vue'

export default class RapportService {
  constructor(private store: Store<any>, private i18n: VueI18n) {
    this.store = store
    this.i18n = i18n
  }

  public getRapports() {
    axios
      .get('api/rapports')
      .then(({data}) => {
        this.store.commit('rapport/setRapports', data)
      })
      .catch(() => {
        Vue.prototype.$edgToast.showError({
          title: this.i18n.t('erreur.titre'),
          message: this.i18n.t('erreur.messageRecuperationRapports')
        })
      })
  }
}
